import {
    ApiParameter,
    doesNotHaveExpand,
    get,
    HasPagingParameters,
} from "@insite/client-framework/Services/ApiService";
import { InvoiceCollectionModel, InvoiceModel } from "@insite/client-framework/Types/ApiModels";

export interface GetInvoicesApiParameter extends ApiParameter, HasPagingParameters {
    invoiceNumber?: string;
    orderNumber?: string;
    poNumber?: string;
    search?: string;
    status?: string[];
    customerSequence?: string;
    fromDate?: string;
    toDate?: string;
    showOpenOnly?: boolean;
}

export interface GetInvoiceApiParameter extends ApiParameter {
    invoiceNumber: string;
    expand?: "invoiceLines"[];
    additionalExpands?: string[];
    sTEmail?: string;
    sTPostalCode?: string;
}

const invoicesUrl = "/api/v1/invoices";
const customInvoicesUrl = "/api/v1/custominvoices";

export async function getInvoices(parameter: GetInvoicesApiParameter) {
    const invoices = await get<InvoiceCollectionModel>(invoicesUrl, parameter);
    invoices.invoices?.forEach(o => cleanInvoice(o));
    return invoices;
}

export async function getInvoice(parameter: GetInvoiceApiParameter) {
    const { invoiceNumber, ...newParameter } = parameter;
    const invoice = await get<InvoiceModel>(`${customInvoicesUrl}/${invoiceNumber}`, newParameter);
    cleanInvoice(invoice, parameter);
    return invoice;
}

function cleanInvoice(invoice: InvoiceModel, parameter?: { expand?: string[]; additionalExpands?: string[] }) {
    if (!invoice.properties) {
        invoice.properties = {};
    }
    invoice.properties["originalId"] = invoice.id;
    invoice.id = invoice.invoiceNumber;
}
